import { normalizeIndianMobileDigits } from './phone';

/** CRM / auth placeholder emails — do not show on the book form. */
export function isDummyBookingEmail(email) {
  const e = String(email || '').trim().toLowerCase();
  if (!e) return true;
  if (e.endsWith('@booking.local')) return true;
  if (/^user_\d+@booking\.local$/i.test(e)) return true;
  if (/^\d{10,}@booking\.local$/i.test(e)) return true;
  return false;
}

/** Real email for prefill, or '' when null / placeholder. */
export function emailForBookingPrefill(email) {
  if (isDummyBookingEmail(email)) return '';
  return String(email || '').trim();
}

/** Loose but practical email format check (empty string is not valid — caller skips empty). */
export function isValidEmailFormat(email) {
  const e = String(email || '').trim();
  if (!e) return false;
  // Basic RFC-inspired pattern: local@domain.tld
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e);
}

/** Some accounts only have mobile embedded in a dummy email (e.g. 9966436633@booking.local). */
export function mobileFromDummyBookingEmail(email) {
  const e = String(email || '').trim().toLowerCase();
  const m = e.match(/^(\d{10})@booking\.local$/);
  return m ? m[1] : '';
}

/** Map API / JWT user shapes to fields used for booking prefill. */
export function normalizeUserProfileFromApi(data, fallback = {}) {
  if (!data || typeof data !== 'object') return { ...fallback };

  const id = String(data.id ?? data.userId ?? data.user_id ?? fallback.id ?? '').trim();
  const name =
    data.name ||
    data.username ||
    data.fullName ||
    data.full_name ||
    [data.firstName || data.first_name, data.lastName || data.last_name].filter(Boolean).join(' ').trim() ||
    fallback.name ||
    '';
  const rawEmail = data.email || data.emailAddress || data.email_address || fallback.email || '';
  const email = emailForBookingPrefill(rawEmail);
  let mobileNumber =
    data.mobileNumber ||
    data.mobile_number ||
    data.mobile ||
    data.phone ||
    data.phoneNumber ||
    data.phone_number ||
    data.contact ||
    fallback.mobileNumber ||
    '';
  if (!String(mobileNumber || '').trim()) {
    mobileNumber = mobileFromDummyBookingEmail(rawEmail) || mobileNumber;
  }

  return {
    ...data,
    ...(id ? { id, userId: id } : {}),
    ...(name ? { name: String(name).trim() } : {}),
    ...(email ? { email } : {}),
    ...(mobileNumber
      ? { mobileNumber: normalizeIndianMobileDigits(mobileNumber) }
      : {}),
  };
}
